import Cookies from 'js-cookie';

import { LANGUAGE_COOKIE_KEY } from '../constants';

/**
 * Gets new language cookie value
 */
export const getLanguageCookieValue = () => Cookies.get(LANGUAGE_COOKIE_KEY);
